import * as i0 from '@angular/core';
import { EventEmitter, Component, ChangeDetectionStrategy, ViewEncapsulation, HostBinding, ContentChildren, forwardRef, Output, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { EuiButtonComponent } from '@eui/components/eui-button';
import { BaseDirective } from '@eui/components/shared';

class EuiButtonGroupComponent extends BaseDirective {
    constructor() {
        super();
        this.buttonClick = new EventEmitter();
        this._isCheckboxButtons = false;
        this._isRadioButtons = false;
    }
    get cssClasses() {
        return [
            super.getCssClasses('eui-button-group'),
        ].join(' ').trim();
    }
    get isCheckboxButtons() { return this._isCheckboxButtons; }
    set isCheckboxButtons(value) { this._isCheckboxButtons = coerceBooleanProperty(value); }
    get isRadioButtons() { return this._isRadioButtons; }
    set isRadioButtons(value) { this._isRadioButtons = coerceBooleanProperty(value); }
    ngAfterContentInit() {
        this.buttons.map((b) => {
            b.buttonClick.subscribe(() => { this.handleInnerButtonClick(b); });
        });
    }
    handleInnerButtonClick(button) {
        try {
            if (button.euiAccent && (this.isCheckboxButtons || this.isRadioButtons)) {
                button.euiAccent = false;
            }
            else {
                if (this.isRadioButtons) {
                    this.buttons.find(b => b.id === button.id).euiAccent = true;
                    this.buttons.forEach((b) => {
                        if (b.id !== button.id) {
                            b.euiAccent = false;
                        }
                    });
                }
                else if (this.isCheckboxButtons) {
                    this.buttons.find(b => b.id === button.id).euiAccent = true;
                }
            }
            this.buttonClick.emit(button);
        }
        catch (e) {
            console.log(e);
        }
    }
}
/** @nocollapse */ EuiButtonGroupComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiButtonGroupComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ EuiButtonGroupComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.3", type: EuiButtonGroupComponent, selector: "eui-button-group", inputs: { isCheckboxButtons: "isCheckboxButtons", isRadioButtons: "isRadioButtons" }, outputs: { buttonClick: "buttonClick" }, host: { properties: { "class": "this.cssClasses" } }, queries: [{ propertyName: "buttons", predicate: i0.forwardRef(function () { return EuiButtonComponent; }) }], usesInheritance: true, ngImport: i0, template: "<ng-content></ng-content>\n", styles: [".eui-button-group{position:relative;display:inline-flex;vertical-align:middle}.eui-button-group>.eui-button:not(:first-child),.eui-button-group>.eui-button-group:not(:first-child){margin-left:-1px}.eui-button-group>.eui-button:not(:last-child),.eui-button-group>.eui-button-group:not(:last-child)>.eui-button{border-bottom-right-radius:0;border-top-right-radius:0}.eui-button-group>.eui-button:not(:first-child),.eui-button-group>.eui-button-group:not(:first-child)>.eui-button{border-bottom-left-radius:0;border-top-left-radius:0}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiButtonGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'eui-button-group', changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, template: "<ng-content></ng-content>\n", styles: [".eui-button-group{position:relative;display:inline-flex;vertical-align:middle}.eui-button-group>.eui-button:not(:first-child),.eui-button-group>.eui-button-group:not(:first-child){margin-left:-1px}.eui-button-group>.eui-button:not(:last-child),.eui-button-group>.eui-button-group:not(:last-child)>.eui-button{border-bottom-right-radius:0;border-top-right-radius:0}.eui-button-group>.eui-button:not(:first-child),.eui-button-group>.eui-button-group:not(:first-child)>.eui-button{border-bottom-left-radius:0;border-top-left-radius:0}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { cssClasses: [{
                type: HostBinding,
                args: ['class']
            }], buttons: [{
                type: ContentChildren,
                args: [forwardRef(() => EuiButtonComponent)]
            }], buttonClick: [{
                type: Output
            }], isCheckboxButtons: [{
                type: Input
            }], isRadioButtons: [{
                type: Input
            }] } });
class EuiButtonGroupModule {
}
/** @nocollapse */ EuiButtonGroupModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiButtonGroupModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ EuiButtonGroupModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: EuiButtonGroupModule, declarations: [EuiButtonGroupComponent], imports: [CommonModule], exports: [EuiButtonGroupComponent] });
/** @nocollapse */ EuiButtonGroupModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiButtonGroupModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiButtonGroupModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                    ],
                    declarations: [
                        EuiButtonGroupComponent,
                    ],
                    exports: [
                        EuiButtonGroupComponent,
                    ],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { EuiButtonGroupComponent, EuiButtonGroupModule };
